import elementResizeDetectorMaker from 'element-resize-detector';
import offset from 'dom-helpers/query/offset';

export default (onResize) => {
  let unbindElementResizeDetector;
  return (el) => {
    if (el) {
      const erd = elementResizeDetectorMaker({ strategy: 'scroll' });

      erd.listenTo(el, () => {
        const { width, height } = offset(el);
        onResize({ el, width, height });
      });

      unbindElementResizeDetector = () => {
        erd.removeAllListeners(el);
      };
    } else {
      unbindElementResizeDetector();
    }
  };
};



// WEBPACK FOOTER //
// ./src/utils/createElementResizeDetectorRef.js